/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_No_BranchesInputs */

const en_users_form_no_branches = /** @type {(inputs: Users_Form_No_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No branches found.`)
};

const pt_br2_users_form_no_branches = /** @type {(inputs: Users_Form_No_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma filial encontrada.`)
};

/**
* | output |
* | --- |
* | "No branches found." |
*
* @param {Users_Form_No_BranchesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_no_branches = /** @type {((inputs?: Users_Form_No_BranchesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_No_BranchesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_no_branches(inputs)
	return pt_br2_users_form_no_branches(inputs)
});